<template>
    <v-app>
        <v-content v-if="loading">
            <v-container class="fill-height">
                <v-row
                    align="center"
                    justify="center"
                >
                    <v-col
                        cols="12"
                        class="text-center"
                    >
                        Memuat tryout
                    </v-col>
                    <v-col
                        cols="6"
                        md="4"
                    >
                        <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>

        <template v-else>
            <question-navigator></question-navigator>

            <app-bar></app-bar>

            <v-content>
                <question-content></question-content>
                <finish-dialog></finish-dialog>
                <mobile-navigation></mobile-navigation>
            </v-content>
        </template>
    </v-app>
</template>

<script>
import QuestionNavigator from '@/components/tryout/QuestionNavigator'
import AppBar from '@/components/tryout/AppBar'
import QuestionContent from '@/components/tryout/QuestionContent'
import FinishDialog from '@/components/tryout/FinishDialog'
import MobileNavigation from '@/components/tryout/MobileNavigation'
import finishTryoutMixin from '@/components/tryout/finishTryoutMixin'

export default {
    mixins: [finishTryoutMixin],

    components: {
        AppBar,
        QuestionNavigator,
        QuestionContent,
        FinishDialog,
        MobileNavigation,
    },

    data() {
        return {
            loading: true,
            intervalId: null,
            routeInformation: null,
        }
    },

    methods: {
        startTimer() {
            this.intervalId = setInterval(() => {
                this.$store.commit('tryout/RUN_TIMER')

                if (this.$store.get('tryout/remaining_second') <= 0) {
                    this.$store.dispatch('flash/info', 'Waktu telah habis')
                    this.finishTryout()
                    // TODO: Replace with proper timeout message
                    this.$router.replace({ name: 'loading' })
                    this.stopTimer()
                }
            }, 1000)
        },

        stopTimer() {
            if (this.intervalId) {
                clearInterval(this.intervalId)
            }
        },
    },

    created() {
        const history_hash = this.$route.params.history_hash

        let randomQuestionMap = []

        this.$api
            .get(`work/${history_hash}`)
            .then((response) => {
                if (response.state == 'finished') {
                    Promise.reject(new Error('finished'))
                }

                this.$store.set('tryout/history_hash', history_hash)
                this.$store.set('tryout/state', response.data.state)
                this.$store.set('tryout/title', response.data.title)
                this.$store.set(
                    'tryout/remaining_second',
                    response.data.remaining_second
                )
                this.$store.set(
                    'tryout/questionRandomized',
                    response.data.is_question_randomized
                )

                this.$tracking.pageViewByTitle(
                    'Pengerjaan: ' +
                        response.data.title +
                        ' ' +
                        this.$store.get('enrollment/selected@title'),
                    this.routeInformation
                )

                return this.$api.get(`work/${history_hash}/question`)
            })
            .then((response) => {
                let questions = response.data.questions

                if (this.$store.get('tryout/questionRandomized')) {
                    // https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
                    for (let i = questions.length - 1; i > 0; i--) {
                        let j = Math.floor(Math.random() * (i + 1))

                        let temp = questions[i]
                        questions[i] = questions[j]
                        questions[j] = temp

                        randomQuestionMap.push([i, j])
                    }
                }

                this.$store.set('tryout/questions', questions)
                this.$store.set('tryout/activeQuestionIdx', 0)

                return this.$api.get(`work/${history_hash}/answer`)
            })
            .then((response) => {
                let answers = response.data.answers

                if (this.$store.get('tryout/questionRandomized')) {
                    for (let i = 0; i < randomQuestionMap.length; i++) {
                        let temp = answers[randomQuestionMap[i][0]]
                        answers[randomQuestionMap[i][0]] =
                            answers[randomQuestionMap[i][1]]
                        answers[randomQuestionMap[i][1]] = temp
                    }
                }

                this.$store.set('tryout/answers', answers)

                if (this.$store.get('tryout/state') != 'ongoing') {
                    return this.$api.post(`work/${history_hash}/start`)
                }
            })
            .then(() => {
                this.startTimer()

                this.loading = false
            })
            .catch((error) => {
                if (error.message == 'finished') {
                    this.$router.replace({
                        name: 'grade.detail',
                        params: { history_hash },
                    })
                } else {
                    throw error
                }
            })
    },

    beforeDestroy() {
        this.stopTimer()

        this.$store.commit('tryout/RESET')
    },

    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.routeInformation = { to, from }
        })
    },
}
</script>
